import React from 'react'
import {
    ChevronDownIcon,
    ChevronRightIcon,
    CogIcon,

    PlusIcon,

} from '@heroicons/react/outline'
import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import { TransProps } from '@lingui/react'
import { Disclosure } from '@headlessui/react';
import { classNames, getColor } from 'components/utils';


// Types
export type typeDropDownBlockWrapper = {
    variant?: string,
    header: React.ReactElement<TransProps>
    addButtonHandler?: React.Dispatch<React.SetStateAction<boolean>>
    configButtonHandler?: React.Dispatch<React.SetStateAction<boolean>>
    icon?: React.ReactElement
    count?: number
    defaultOpen?: boolean
}

// Component
export const DropDownBlockWrapper: React.FC<typeDropDownBlockWrapper> = ({
                                                                   variant,
                                                                   children,
                                                                   header,
                                                                   addButtonHandler,
                                                                   configButtonHandler,
                                                                   icon,
                                                                   count,
                                                                             defaultOpen=false
                                                               }) => {
    const color = getColor(variant)

    return (

        <Disclosure as="div" className="space-y-1" defaultOpen={ defaultOpen }>
            { ({ open }) => (
                <>
                    <Disclosure.Button
                        className={ classNames(
                            !open
                                ? 'bg-gray-100 text-gray-500 hover:bg-gray-100 hover:text-gray-600'
                                : `text-gray-500 bg-gray-200 hover:bg-gray-100 hover:text-gray-600 focus:ring-1 focus:ring-${ color }-500`,
                            `group w-full flex justify-start sm:items-center pl-2 pr-1 py-2 text-left text-sm font-medium rounded-md focus:outline-none `
                        ) }
                    >
                        <div className="flex flex-wrap gap-x-2 items-center">
                            { icon }
                            <h3 className="font-medium text-xl">{ header }</h3>

                        </div>
                        { open
                            ? <ChevronDownIcon
                                className="text-gray-400 ml-5 flex-shrink-0 h-6 w-6  mr-1"
                            />
                            : <ChevronRightIcon
                                className="text-gray-500 group-hover:text-gray-500  flex-shrink-0 h-6 w-6 ml-5"
                            />
                        }
                    </Disclosure.Button>
                    <Disclosure.Panel className="space-y-1">
                        <div className={ 'flex justify-between' }>
                            <div className={ 'flex ' }>
                                { addButtonHandler &&
                                    <Button variant={ variant } buttonClassName=" mr-5 mt-2 mb-1" type="button"
                                            secondary={ true }
                                            icon={ <PlusIcon className="h-6 w-6 mr-1"/> } label={ <Trans>Add</Trans> }
                                            onClick={ () => addButtonHandler(true) }/> }
                                { configButtonHandler &&
                                    <Button variant={ variant } buttonClassName="mr-5 mt-2 mb-1" type="button"
                                            secondary={ true }
                                            icon={ <CogIcon className="h-6 w-6 mr-1"/> }
                                            label={ <Trans>FM config</Trans> }
                                            onClick={ () => configButtonHandler(true) }/> }

                            </div>
                            { !!count && <div className={'flex items-center'}>
                                <div className={ `flex gap-2 items-baseline border-b border-gray-400 px-2 py-1  md:mr-2` }>
                                    <span className="text-sm text-gray-500"><Trans>all</Trans>:</span>
                                    <span className="text-gray-700 font-medium">{ count }</span>
                                </div>
                            </div>
                            }


                        </div>
                        <div className={'px-2'}>
                            { children }
                        </div>

                    </Disclosure.Panel>
                </>
            ) }
        </Disclosure>

    )
}
